import React__default from "react";
const TransitionGroupContext = /*#__PURE__*/React__default.createContext(null);
export { TransitionGroupContext as default };